import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi } from "../api";
import { AField, Btn, PageHead, Toggle, inputCls } from "../components";

export default function Homepage() {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminApi.get("/admin/config").then((r) => setCfg(r.data)).catch(() => {});
  }, []);

  if (!cfg) return <p className="font-mono text-xs text-clay animate-pulse">LOADING HOMEPAGE CONFIG...</p>;

  const set = (k) => (e) => setCfg({ ...cfg, [k]: e.target.value });
  const setMetric = (i, k) => (e) => {
    const metrics = cfg.metrics.map((m, idx) => (idx === i ? { ...m, [k]: k === "value" ? Number(e.target.value) : e.target.value } : m));
    setCfg({ ...cfg, metrics });
  };

  const save = async () => {
    setSaving(true);
    try {
      await adminApi.put("/admin/config", {
        hero_eyebrow: cfg.hero_eyebrow,
        hero_subtitle: cfg.hero_subtitle,
        newsletter_heading: cfg.newsletter_heading,
        newsletter_sub: cfg.newsletter_sub,
        metrics: cfg.metrics,
        show_team: cfg.show_team,
        show_shop: cfg.show_shop,
      });
      toast.success("Homepage content updated — live immediately.", { id: "cfg-save" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-homepage">
      <PageHead title="HOMEPAGE" sub="Homepage copy and visibility. Design stays locked to the Cobain system — this controls content only.">
        <Btn variant="gold" onClick={save} disabled={saving} data-testid="homepage-save">{saving ? "SAVING..." : "SAVE HOMEPAGE"}</Btn>
      </PageHead>

      <div className="space-y-6 max-w-3xl">
        <div className="border border-woodborder bg-card/40 p-6 space-y-5">
          <p className="font-mono text-[10px] tracking-[0.25em] text-tan">HERO</p>
          <AField label="HERO EYEBROW"><input className={inputCls} value={cfg.hero_eyebrow || ""} onChange={set("hero_eyebrow")} data-testid="homepage-hero-eyebrow" /></AField>
          <AField label="HERO SUPPORTING COPY"><textarea className={`${inputCls} min-h-[80px] resize-y`} value={cfg.hero_subtitle || ""} onChange={set("hero_subtitle")} data-testid="homepage-hero-subtitle" /></AField>
        </div>

        <div className="border border-woodborder bg-card/40 p-6 space-y-5">
          <p className="font-mono text-[10px] tracking-[0.25em] text-tan">THE REACH — AUDIENCE METRICS</p>
          {(cfg.metrics || []).map((m, i) => (
            <div key={i} className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid={`homepage-metric-${i}`}>
              <AField label="VALUE"><input type="number" className={inputCls} value={m.value} onChange={setMetric(i, "value")} data-testid={`homepage-metric-value-${i}`} /></AField>
              <AField label="SUFFIX"><input className={inputCls} value={m.suffix} onChange={setMetric(i, "suffix")} data-testid={`homepage-metric-suffix-${i}`} /></AField>
              <AField label="LABEL"><input className={inputCls} value={m.label} onChange={setMetric(i, "label")} data-testid={`homepage-metric-label-${i}`} /></AField>
              <AField label="NOTE"><input className={inputCls} value={m.note || ""} onChange={setMetric(i, "note")} data-testid={`homepage-metric-note-${i}`} /></AField>
            </div>
          ))}
        </div>

        <div className="border border-woodborder bg-card/40 p-6 space-y-5">
          <p className="font-mono text-[10px] tracking-[0.25em] text-tan">NEWSLETTER MESSAGING</p>
          <AField label="HEADING"><input className={inputCls} value={cfg.newsletter_heading || ""} onChange={set("newsletter_heading")} data-testid="homepage-newsletter-heading" /></AField>
          <AField label="SUPPORTING COPY"><input className={inputCls} value={cfg.newsletter_sub || ""} onChange={set("newsletter_sub")} data-testid="homepage-newsletter-sub" /></AField>
        </div>

        <div className="border border-woodborder bg-card/40 p-6 flex flex-wrap gap-8">
          <Toggle checked={!!cfg.show_team} onChange={(v) => setCfg({ ...cfg, show_team: v })} label="SHOW MEET THE TEAM" testId="homepage-show-team" />
          <Toggle checked={!!cfg.show_shop} onChange={(v) => setCfg({ ...cfg, show_shop: v })} label="SHOW COBAIN CULTURE" testId="homepage-show-shop" />
        </div>
      </div>
    </div>
  );
}
